import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';
import { APP_CONFIG } from '../../utils/constants';
import { openWhatsApp } from '../../utils/whatsapp';
import { whatsAppBrandSx } from '../../theme/interactions';

interface WhatsAppButtonProps {
  position?: 'fixed' | 'relative';
  bottom?: number;
  right?: number;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ 
  position = 'fixed', 
  bottom = 24, 
  right = 24 
}) => {
  const { language } = useLanguage();

  const handleWhatsAppClick = () => {
    const phoneNumber = APP_CONFIG.WHATSAPP_NUMBER;
    const message = language === 'en' 
      ? 'Hello, I need help with the Veresiye application.'
      : 'Merhaba, Veresiye uygulaması hakkında yardıma ihtiyacım var.';
    openWhatsApp({ phoneNumber, message });
  };

  const tooltipText = language === 'en' ? 'Contact via WhatsApp' : 'WhatsApp ile İletişim';

  return (
    <Tooltip title={tooltipText}>
      <Fab
        color="success"
        onClick={handleWhatsAppClick}
        sx={{
          position,
          bottom,
          right,
          ...whatsAppBrandSx,
          zIndex: 1000,
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton;
